import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{
    hasAiPermission: boolean;
  }>()
  .create(({ hasAiPermission }) => ({
    templateContainer: {
      width: hasAiPermission ? '25%' : '33%',
      '.MuiStack-root': {
        alignItems: 'center'
      }
    }
  }));

export default useStyles;
